import 'scripts/main.js'
import 'style/main.scss'




// WEBPACK FOOTER //
// app/javascript/packs/application.js